import { MutableRefObject, useEffect, useState } from 'react';

export const useTextOverflow = ({
  textElementRef,
  withVerticalOverflow,
}: {
  textElementRef: MutableRefObject<HTMLElement | null>;
  withVerticalOverflow?: boolean;
}) => {
  const [isOverflowed, setIsOverflow] = useState(false);
  useEffect(() => {
    const textElement = textElementRef?.current as HTMLElement;
    const trigger = () => {
      const isHorizontalOverflowed =
        textElement?.scrollWidth > textElement?.clientWidth;

      const isVerticalOverflowed =
        textElement?.scrollHeight > textElement?.clientHeight;

      const isTextOverflowed = withVerticalOverflow
        ? isHorizontalOverflowed || isVerticalOverflowed
        : isHorizontalOverflowed;

      setIsOverflow(isTextOverflowed);
    };

    if (textElement) {
      if ('ResizeObserver' in window) {
        new ResizeObserver(trigger).observe(textElement);
      }

      trigger();
    }
  }, [textElementRef.current, withVerticalOverflow]);

  return isOverflowed;
};
